/**
 * function for getting user's first and last names from amazon api, because the sandbox sends both of them joined in familyName
 * @param {string} givenName - given name
 * @param {string} familyName - familyName
 * @returns {Object} - object with first name and last name fields
 */
export const getFirstLastNames = (
    givenName = '',
    familyName: string,
): {firstName: string; lastName: string} => {
    const nameArray = familyName.split(' ');

    if (nameArray.length === 1) return {firstName: givenName || familyName, lastName: familyName};

    return {firstName: nameArray[0], lastName: nameArray.slice(1).join(' ')};
};
